import resets from "./resets";
import theme from "./theme";
import baseAppearance from "./appearance";
import baseTypography from "./typography";
import baseLayout from "./layout";

export default `
  ${resets}
  ${theme}
  ${baseAppearance}
  ${baseTypography}
  ${baseLayout}
`;
